import React, {Component} from 'react'
import {Badge, Modal, Icon, Button} from "antd"

class ModalResults extends Component {
    componentDidMount() {
        const {session_id, onRefresh} = this.props

        this.interval = setInterval(() => {
            !this._isFinish() && onRefresh(session_id)
        }, 15000)
    }

    _isFinish = () => {
        const {data} = this.props
        return !data.find(item => item.queue_job.status !== 'done' && item.queue_job.status !== 'error')
    }

    _stopInterval() {
        clearInterval(this.interval)
    }

    componentWillUnmount() {
        this._stopInterval()
    }

    _genStatus = (status) => {
        let iconStatus = ''
        switch (status) {
            case 'pending':
                iconStatus = <Badge
                    count={status}
                    style={{backgroundColor: '#03a9f4', color: '#fff'}}
                />
                break
            case 'processing':
                iconStatus = <Badge
                    count={status}
                    style={{backgroundColor: '#00acc1', color: '#fff'}}
                />
                break
            case 'done':
                iconStatus = <Badge
                    count={status}
                    style={{backgroundColor: '#00c853', color: '#fff'}}
                />
                break
            case 'error':
                iconStatus = <Badge
                    count={status}
                    style={{backgroundColor: '#dc3545', color: '#fff'}}
                />
                break
            default:
        }
        return iconStatus
    }

    render() {
        const {showModal, data, closeModal, error, session_id, isErrorAll, onRetryPrintFileSession, loading, listErrorRetry, onRefresh} = this.props

        return (
            <Modal
                title="Generate lại file in"
                visible={showModal}
                onCancel={closeModal}
                footer={[
                    <div key="footer" className="Footer d-flex justify-content-between align-items-center">
                        <div>
                            {(!this._isFinish()) && 
                                <div className="mr-3"><Icon type="sync" spin className='text-success'/> Đang generate lại file in...</div>
                            }
                        </div>
                        {isErrorAll && <Button type="primary" onClick={onRetryPrintFileSession} disabled={loading}>
                            Thử lại
                        </Button>}
                        {!!listErrorRetry && !!listErrorRetry.length && <Button type="primary" onClick={() => onRefresh(null, listErrorRetry)} disabled={loading}>
                            Lọc lỗi
                        </Button>}
                        {/* <Button className='ml-3' type='default' onClick={closeModal}>
                            Đóng
                        </Button> */}
                    </div>,
                ]}
            >
                {
                    data.length > 0 && (
                        <div>
                            <div className="mb-3">
                                <div className="mb-3">Các items đang generate lại file in:</div>
                                <div className="wrapReGen">
                                    {
                                        data.map((item, index) => {
                                            return (
                                                <div className="mb-1" key={index}>
                                                    {this._genStatus(item.queue_job.status)}
                                                    <strong className='ml-2'>#{item.barcode_number}</strong>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            {
                                (error && session_id) && <div className="text-danger mb-3">{error}</div>

                            }
                        </div>
                    )
                }
            </Modal>
        )
    }

}

export default ModalResults